import $ from 'jquery';

import Section from '../Section';
import KenBurns from '../global/KenBurns';

export default class Hero extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.kenBurns = new KenBurns(theme, element);
    $(".homepage-hero-text-advert-link").each((index, link) => {
      this.hoverEffect($(link));
    });

    $('.homepage-hero-menu li').each((index, link) => {
      this.hoverEffect($(link));
    });
  }

  hoverEffect = ($link) => {
    const $overlay = $('#' + $link.data('overlayId'));
    $link.hover(
      () => {
        $overlay.addClass("active");
      },
      () => {
        $overlay.removeClass("active");
      },
    );

    // Apply hover on page load
    if ($link.is(':hover')) {
      $overlay.addClass("active");
    }
  }
}
